'use client'

import api from "@/util/api"
import { createContext, ReactNode, useEffect, useState } from "react"
import { isMobile } from "react-device-detect"

export interface bannerTypes {
    banner_type:         number,
    banner_type_display: string,
    title:               string,
    image_url:           string,
    redirect_url:        string,
    is_active:           boolean,
    update_dt:           string
}
interface fetchTypes {
    main_top_banner: bannerTypes[]
    main_banner: bannerTypes[]
    page_top_banner: Map<number, bannerTypes>
    sub_top_banner: bannerTypes[]
    sub_middle_banner: bannerTypes[]
    sub_midbtm_banner: bannerTypes[]
    sub_bottom_banner: bannerTypes[]
    site_banner: bannerTypes[]
}

export const BannerContext = createContext<fetchTypes>({
    main_top_banner: [],
    main_banner: [],
    page_top_banner: new Map(),
    sub_top_banner: [],
    sub_middle_banner: [],
    sub_midbtm_banner: [],
    sub_bottom_banner: [],
    site_banner: [],
})

export default function BannerProvider({children}: {children: ReactNode}){
    const [main_top_banner, set_main_top_banner] = useState<bannerTypes[]>([])
    const [main_banner, set_main_banner] = useState<bannerTypes[]>([])
    const [page_top_banner, set_page_top_banner] = useState<Map<number, bannerTypes>>(new Map())
    const [sub_middle_banner, set_sub_middle_banner] = useState<bannerTypes[]>([])
    const [sub_bottom_banner, set_sub_bottom_banner] = useState<bannerTypes[]>([])
    const [sub_top_banner, set_sub_top_banner] = useState<bannerTypes[]>([])
    const [sub_midbtm_banner, set_sub_midbtm_banner] = useState<bannerTypes[]>([])
    const [site_banner, set_site_banner] = useState<bannerTypes[]>([])

    function bannerFetch(){
        api(`/api/banner/${ isMobile ? "?device_type=mobile" : "" }`)
            .then(res=> res.json())
            .then(({ data })=> {
                // console.log("bannerFetch: ", data)

                data.main_banner       && set_main_banner(data.main_banner)
                data.main_top_banner   && set_main_top_banner(data.main_top_banner)
                data.sub_middle_banner && set_sub_middle_banner(data.sub_middle_banner)
                data.sub_bottom_banner && set_sub_bottom_banner(data.sub_bottom_banner)
                data.sub_top_banner && set_sub_top_banner(data.sub_top_banner)
                data.sub_midbtm_banner && set_sub_midbtm_banner(data.sub_midbtm_banner)
                data.site_banner       && set_site_banner(data.site_banner)

                // 페이지 베너만 맵맵
                const page_top_banner = data.page_top_banner
                const page_top_banner_map = new Map()

                page_top_banner?.forEach((el: bannerTypes)=> {
                    page_top_banner_map.set(el.banner_type, { ...el })
                })
                

                set_page_top_banner(page_top_banner_map)
            })
            .catch((error: Response) =>{
                console.log("bannerFetch: ",error)
            })
    }

    useEffect(()=> {
        bannerFetch()
    }, [isMobile])

    const propsValue = {
        main_top_banner,
        main_banner,
        page_top_banner,
        sub_middle_banner,
        sub_bottom_banner,
        sub_top_banner,
        sub_midbtm_banner,
        site_banner,
    }
    return (
        <BannerContext.Provider value={propsValue}>{children}</BannerContext.Provider>
    )
}